<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">

        <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />

        <label class="search-label">状态</label>
        <Select v-model="status" class="search-input" clearable>
          <Option v-for="item in statusIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">工作类型</label>
        <Select v-model="work_type_id" class="search-input" clearable>
          <Option v-for="item in workTypeIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">平台</label>
        <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">视频分类</label>
        <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable>
          <Option v-for="item in videoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">执行账号</label>
        <Select v-model="user_id" class="search-input" clearable filterable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <Button @click="handleButtonSearch" class="search-btn" type="primary">搜索</Button>
        </Col>
      </Row>

      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]" show-sizer
            show-elevator @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>

    <Modal :mask-closable="false" v-model="addModal" title="编辑翻译任务" footer-hide>
      <forms :resetFlag="resetFlag" ref="editTranslateTextTask" @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Forms from './edit_translate_text_form.vue'
import Tables from '_c/tables/table-only.vue'
import saveAs from '@/api/FileSaver'
import { uploadIdFile, uploadFile } from '@/api/uploadOss'
import moment from 'moment'

import { getTranslateTextList, editTranslateTextTask, finishTranslateTextTask, getTranslateTextDetail, deleteTranslate,
  getShortVideoWorkTypeList, getShortVideoClassify, getLiveType, getStrategyUser, endTranslateTask, resetTranslateTask } from '@/api/data'
const { v4: uuidv4 } = require('uuid')
export default {
  name: 'finance',
  components: {
    Tables,
    Forms
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat: false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      allMoney: 0.0,
      startTime: '',
      endTime: '',
      wxContacts: [],
      statusIds: [{ id: -1, name: '全部' }, { id: 0, name: '待处理' }, { id: 2, name: '等待提交' }, { id: 4, name: '已完成' }, { id: 5, name: '任务终止' }],
      live: '',
      user: '',
      user_id: '',
      keyword: '',
      userIds: [],
      liveIds: [],
      workTypeIds: [],
      videoClassifyIds: [],
      live_id: '',
      work_type_id: '',
      video_classify_id: '',
      update_id: true,
      status: -1,
      columns: [
        {
          title: '主id',
          width: 100,
          align: 'center',
          key: 'id',
          render: (h, params) => {
            let texts = params.row.checkSrtTask.shortVideoTask.id
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        { title: 'id', width: 100, key: 'id', editable: true, align: 'center' },
        {
          title: '自动化',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            var texts = '手动'
            if (params.row.checkSrtTask.shortVideoTask.auto) {
              texts = '自动'
            }
            return h(
              'div',
              {
                props: {},
                style: {
                  color: params.row.checkSrtTask.shortVideoTask.auto ? '#ff0000' : '#515a6e'
                }
              },
              texts
            )
          }
        },
        {
          title: '执行人',
          key: 'nickname',
          editable: true,
          align: 'center',
          render: (h, params) => {
            var texts = ''
            var list = params.row.list
            if (list.length != 0) {
              for (var i = 0; i < list.length; i++) {
                texts += list[i].username + '\n'
              }
            }
            return h(
              'pre',
              texts
            )
          }
        },
        {
          title: '语言',
          key: 'work_type_name',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.list[0].language
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        {
          title: '类型',
          key: 'work_type_name',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.checkSrtTask.shortVideoTask.work_type_name
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        {
          title: '分类',
          key: 'video_classify',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.checkSrtTask.shortVideoTask.video_classify
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        }, {
          title: '标题',
          key: '',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              // 显示的位置上方
              h('Tooltip', {
                props: { placement: 'top', transfer: true }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '70px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }
                }, params.row.checkSrtTask.shortVideoTask.video_title),
                // 显示的内容
                h('span', {
                  slot: 'content',
                  style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                }, params.row.checkSrtTask.shortVideoTask.video_title)
              ])
            ])
          }
        },
        {
          title: '翻译前的字幕地址',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return params.row.checkSrtTask.shortVideoTask.short_video_work_type_id != 2 && params.row.checkSrtTask.shortVideoTask.short_video_work_type_id != 3 ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.downloadSrt(params, 1)
                    }
                  }
                },
                '下载'
              )
            ]) : h('span', '')
          }
        }, {
          title: '翻译后字幕地址',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return params.row.checkSrtTask.shortVideoTask.short_video_work_type_id != 2 && params.row.checkSrtTask.shortVideoTask.short_video_work_type_id != 3 ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.downloadSrt(params, 2)
                    }
                  }
                },
                '下载'
              )
            ]) : h('span', '')
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            var texts = '已完成'
            if (params.row.status == 0) {
              texts = '待处理'
            } else if (params.row.status == 1) {
              texts = '翻译中'
            } else if (params.row.status == 2) {
              texts = '等待提交'
            } else if (params.row.status == 3) {
              texts = '翻译失败'
            } else if (params.row.status == 5) {
              texts = '任务终止'
            }

            var color = '#03A9F4'
            if (params.row.status == 3) {
              color = '#ff0000'
            } else if (params.row.status == 4) {
              color = '#515a6e'
            }
            return h(
              'div',
              {
                props: {},
                style: {
                  color: color
                }
              },
              texts
            )
          }
        },
        { title: '创建时间', key: 'create_time', editable: true, align: 'center' },
        { title: '完成时间', key: 'finish_time', editable: true, align: 'center' },
        {
          title: 'Handle',
          key: 'handle',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.translateCheckView(params)
                    }
                  }
                },
                '编辑'
              ), params.row.status != 4 && params.row.status != 5 ? h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleFinish(params)
                    }
                  }
                },
                '完成'
              ) : h('span', ''),
              params.row.status == 3 || params.row.status == 1 ? h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handReset(params)
                    }
                  }
                },
                '重新翻译'
              ) : h('span', ''),
              params.row.status != 5 ? h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleEnd(params)
                    }
                  }
                },
                '终止'
              ) : h('span', '')
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.handleDelete(params);
              //       },
              //     },
              //   },
              //   "删除"
              // )
            ])
          }
        }
      ],
      tableData: []
    }
  },
  watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch()
    }
  },
  methods: {
    handReset (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认重新翻译该任务？</p>',
        onOk: () => {
          resetTranslateTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    handleButtonSearch () {
      this.page = 1
      this.handleSearch()
    },
    handleEnd (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认终止任务？</p>',
        onOk: () => {
          endTranslateTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    handleDelete (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          deleteTranslate(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    downloadSrt (params, value) {
      var params = {
        id: params.row.id
      }
      getTranslateTextDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data

          var srtJson = ''
          var fileName = ''
          if (value == 1) {
            srtJson = detailData.srt_json
            fileName = 'org' + detailData.id + '.srt'
          } else {
            srtJson = detailData.translate_srt_json
            fileName = 'translate' + detailData.id + '.srt'
          }
          var srt_array = JSON.parse(srtJson)
          var srtContent = this.generateSRT(srt_array, value)
          const blob = new Blob([srtContent], { type: 'text/plain' })

          // 保存文件
          saveAs(blob, fileName)
        }
      })
    },
    generateSRT (subtitles, value) {
      let srtContent = ''
      subtitles.forEach((subtitle, index) => {
        const sequenceNumber = index + 1
        const startTime = subtitle.startTime
        const endTime = subtitle.endTime
        var text = ''
        if (value == 1) {
          text = subtitle.text
        } else {
          if (subtitle.update_translate_text == '' || subtitle.update_translate_text == undefined) {
            text = subtitle.translate_text
          } else {
            text = subtitle.update_translate_text
          }
        }
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${text}\n\n`
      })
      return srtContent
    },
    translateCheckView (params) {
      this.$router.push({ name: 'translate_check', query: { id: params.row.id, language: params.row.language } })
    },
    showEditModal (params) {
      this.addModal = true
      this.$refs.editTranslateTextTask.setEditData(params.row)
    },
    addSumit (formValidate) {
      var blackItems = formValidate.blackItems
      var goodItems = formValidate.goodItems
      const data = {
        black_comment: JSON.stringify(blackItems),
        good_comment: JSON.stringify(goodItems),
        org_video_desc: formValidate.org_video_desc,
        translate_video_desc: formValidate.translate_video_desc,
        org_video_title: formValidate.org_video_title,
        translate_video_title: formValidate.translate_video_title,
        org_srt_path: formValidate.org_srt_path,
        translate_srt_path: formValidate.translate_srt_path,
        org_text: formValidate.org_text,
        translate_text: formValidate.translate_text
      }

      editTranslateTextTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success('成功!')
            this.addModal = false
            this.handleSearch()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    cancel () { },
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
        live_id: this.live_id,
        keyword: this.keyword,
        user_id: this.user_id,
        work_type: this.work_type_id,
        video_classify: this.video_classify_id
      }
      getTranslateTextList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    async getDetail (id) {
      var params = {
        id: id
      }
      var srtContent = ''
      var status = true
      await getTranslateTextDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          var srtJson = detailData.translate_srt_json
          this.update_id = detailData.checkSrtTask.shortVideoTask.update_id
          if (srtJson != null && srtJson != '') {
            var srt_array = JSON.parse(srtJson)
            for (var i = 0; i < srt_array.length; i++) {
              var is_confirm = srt_array[i].is_confirm
              if (!is_confirm) {
                status = false
                break
              }
            }
            if (status) {
              srtContent = this.generateSRT(srt_array, 2)
            }
          }
        }
      })

      if (status) { return srtContent } else { return 'error' }
    },
    async handleFinish (params) {
      // 完成任务得时候把翻译好得srt转换成文件并上传到服务器
      // var srtContent = await this.getDetail(params.row.id)
      // if (srtContent == 'error'){
      //   this.$Message.error("请确认每一条字幕翻译");
      //   return
      // }
      var url = ''
      // if (srtContent != '') {
      //   const blob = new Blob([srtContent], { type: 'text/plain' });
      //   var url = await this.uploadFile(blob)
      // }

      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认提交任务？</p>',
        onOk: () => {
          finishTranslateTextTask(params.row.id, url)
            .then((res) => {
              if (res.data.code == 200) {
                this.$Message.success('成功!')
                this.handleSearch()
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    async uploadFile (blob) {
      // 上传文件
      let currentDate = moment().format('YYYY-MM-DD')
      const uuid = uuidv4()
      var result = ''
      if (this.update_id) {
        result = await uploadIdFile('short_video/' + currentDate + '/translate_srt/' + uuid + '.srt', blob)
      } else {
        result = await uploadFile('short_video/' + currentDate + '/translate_srt/' + uuid + '.srt', blob)
      }
      return result
    },
    setTableLoading (state) {
      this.tableLoading = state
    },
    videoClassifyChange (value) {
      this.getStrategyUser()
    },
    liveChange (value) {
      this.getStrategyUser()
    },
    getStrategyUser () {
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data
      })
    }
  },
  mounted () {
    this.getStrategyUser()
    this.handleSearch()
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    })

    getShortVideoWorkTypeList().then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.workTypeIds = data
    })

    getShortVideoClassify({}).then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.videoClassifyIds = data
    })
  }
}
</script>
